<template>
  <div
    class="portal-page"
    :class="{'pc-bg pc-pd': !isMobile, 'mobile-bg mobile-pd': isMobile}"
  >
    <img
      v-if="!isMobile"
      class="logo-pc"
      src="@/assets/img/portal/logo-pc.png"
      alt="logo"
    />

    <div
      :class="{'slogon-pc': !isMobile, 'slogon-mobile': isMobile}"
    >
      <img
        src="@/assets/img/portal/hello.png"
        alt="slogon"
      />
      <p class="welcome">
        您好!
        <br />
        欢迎来到标签管家！
      </p>
    </div>

    <img
      v-if="!isMobile"
      class="info-pc"
      :src="infoImg"
      alt="logo"
    />
    <div v-else class="info-mobile">
      <img
        src="@/assets/img/portal/info.png"
        alt="logo"
      />
    </div>

    <div
      :class="{'entrances-pc': !isMobile, 'entrances-mobile': isMobile}"
    >
      <div class="item" @click="handleGoLogin">
        <img src="@/assets/img/portal/app.png" alt="dealer">
        <span v-if="isIndex">返回主页</span>
        <span v-else>{{ isMobile ? `登录app` : `登录` }}</span>
      </div>
      <div class="item" @click="handleGoGuide">
        <img src="@/assets/img/portal/guide.png" alt="guide">
        <span>说明文档</span>
      </div>
      <div class="item" @click="showSeller = true">
        <img src="@/assets/img/portal/dealer.png" alt="dealer">
        <span>联系经销商</span>
      </div>
      <div class="item" @click="goSellerPage">
        <img src="@/assets/img/portal/seller.png" alt="seller">
        <span>直销采购</span>
      </div>
      <div class="item" @click="handleGoVideo">
        <img src="@/assets/img/portal/video.png" alt="video">
        <span>演示视频</span>
      </div>
      <div class="item" @click="handleGoPinterInstallGuide(6)">
        <img src="@/assets/img/portal/video.png" alt="video">
        <span>打印机安装视频</span>
      </div>
    </div>

    <img
      v-if="isMobile"
      class="logo-mobile"
      src="@/assets/img/portal/logo-mobile.png"
      alt="logo"
    />

    <el-dialog
      :visible.sync="showSeller"
      :width="isMobile ? '90%': `${boundaryWidth}px`"
      :append-to-body="true"
      :show-close="false"
      custom-class="seller-info-pop"
    >
      <div
        v-if="isMobile"
        class="seller-list-mobile"
      >
        <el-card
          class="item-card"
          v-for="(item, index) in dealers" :key="index"
        >
          <div class="info">
            <span class="label">
              经销商名称：
            </span>
            <span class="title">
              {{item.name}}
            </span>
          </div>

          <div class="info">
            <span class="label">
              联系方式
            </span>
            <a :href="`tel:${item.phone}`">{{ item.phone }}</a>
          </div>

          <div class="info">
            <span class="label">
              地址：
            </span>
            <span>
              {{item.address}}
            </span>
          </div>
        </el-card>
      </div>
      <el-table
        v-else
        :data="dealers"
        border
        style="width: 100%">
        <el-table-column
          prop="country"
          :label="`国家`"
        ></el-table-column>
        <el-table-column
          prop="province"
          :label="`省/直辖市`"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          :label="`经销商名称`"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          :label="`地址`"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          :label="`联系方式`"
        >
          <template slot-scope="scope">
            <a :href="`tel:${scope.row.phone}`">{{ scope.row.phone }}</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="d-flex right" slot="footer">
        <el-button @click="showSeller = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const infoImgCN = require('@/assets/img/portal/info.png');
const infoImgEN = require('@/assets/img/portal/info_en.png');
import { mapGetters } from 'vuex'
import {
  linksForPortal
} from '@/api.js';
import {
  userTokenKey,
  pdaScreenWidth,
  appDownloadPageUrl,
  apiLangKey
} from '@/utils/Config.js'
export default {
  name: 'Portal',
  beforeRouteEnter (to, from, next) { // 判断是否是从标签管家的首页跳转过来的
    next(vm => {
      if (from.path != "/") {
        vm.isIndex = true;
      }
    });
  },
  data() {
    return {
      boundaryWidth: pdaScreenWidth, // 移动端和PC的宽度边界值
      isMobile: false,
      showSeller: false,
      isIndex:false,
      dealers: [
        {
          'country': `中国`,
          'province': `上海市`,
          'name': `上海红柚医疗器械有限公司`,
          'address': `上海市徐汇区钦州北路1188号科汇大厦1701室`,
          'phone': `4008938068`
        },
        {
          'country': `马来西亚`,
          'province': '',
          'name': 'SETIA MEDIK',
          'address': '',
          'phone': ''
        }
      ],
      checkAppTimer: null,
      openApping: false,
      loading: null
    }
  },
  computed: {
    ...mapGetters(['user']),
    infoImg() {
      const apiLang = localStorage.getItem(apiLangKey)
      const isEN = apiLang === 'en'
      // console.log(123, isEN, apiLangKey)
      return isEN ? infoImgEN : infoImgCN
    }
  },
  beforeDestroy(){
    var pageLeaveTime = new Date().getTime();
    var stayDuration = pageLeaveTime - this.pageEnterTime;
    // window._hmt && window._hmt.push(['_trackEvent', '产品介绍页面停留时间', 'stay', '/problem', stayDuration+','+JSON.stringify(this.user)]);
  },
  methods: {
    // 打印机安装视频
    handleGoPinterInstallGuide(){
      this.getVido(6)
    },
    getVido(type){
      const token = this.$cookie.get(userTokenKey)
      if (token) {
        const data = this.links.find(i => i.type == type)
        if (data) {
          const {
            url,
            id
          } = data
          if (id) {
            this.recordVisitLink(id)
          }
          if (url) {
            window.open(url, '_blank')
          }
        }
      } else {
        this.$router.push(`/login?from=portal&type=video`)
      }
    },
    checkMobile() {
      // 判断是否是移动端（或是否按移动端去显示）
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= this.boundaryWidth
    },
    goLogin() {
      // 登录入口
      // pc端（校验token，已存在去首页，不存在去登录页）
      // 移动端（唤起app或去下载app页）
    },
    handleGoLogin() {
      if (this.isMobile) {
        // 下载app或打开app
        this.handleCallOrDownloadApp()
      } else {
        const token = this.$cookie.get(userTokenKey)
        if (token) {
          this.$router.push('/index')
        } else {
          this.$router.push(`/login?from=portal&type=login`)
        }
      }
    },
    handleCallOrDownloadApp() {
      const isWX = /MicroMessenger/i.test(window.navigator.userAgent)
      if (isWX) {
        this.$message.warning(`请使用自带浏览器打开当前链接并重试。`)
      } else {
        this.callOrDownloadApp()
      }
    },
    callOrDownloadApp() {
      // 唤起或下载app
      if (this.openApping) return
      
      const checkDuration = 1500
      this.openApping = true
      this.loading =  this.loading || this.$loading({
        lock: true,
        text: `检测中...`,
        fullscreen: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const frame = document.createElement('iframe')
      frame.src = 'hlms://'
      frame.style.display = 'none'
      document.body.appendChild(frame)
      this.checkAppTimer = setTimeout(() => {
        if (this.openApping) {
          window.location.href = appDownloadPageUrl
        }
      }, checkDuration)
    },
    clearCheckAppTimer() {
      if (this.checkAppTimer) {
        clearTimeout(this.checkAppTimer)
        this.checkAppTimer = null
      }
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
        this.loading = null
      }
    },
    goSellerPage() {
      // 打开有赞地址
      const data = this.links.find(i => i.type == 5)
      if (data) {
        const {
          url,
          id
        } = data

        if (id) {
          this.recordVisitLink(id)
        }

        if (url) {
          window.open(url, '_blank')
        }
      }
    },
    getLinks() {
      // 获取各种外部链接
      return this.$request('get', linksForPortal)
      .then(res => {
        if (res && res.length) {
          this.links = res
        }
      })
    },
    handleGoVideo() {
      // 跳转演示视频
      const type = this.isMobile ? 4 : 3
      this.getVido(type)
    },
    handleGoGuide() {
      const token = this.$cookie.get(userTokenKey)
      if (token) {
        this.goGuide()
      } else {
        this.$router.push(`/login?from=portal&type=guide`)
      }
    },
    goGuide() {
        // 跳转说明文档
        const type = this.isMobile ? 2 : 1
      const data = this.links.find(i => i.type == type)
      if (data) {
        const {
          url,
          id
        } = data

        if (id) {
          this.recordVisitLink(id)
        }

        if (url) {
          window.open(url, '_blank')
        }
      }
    },
    recordVisitLink(id) {
      const params = {
        id
      }

      return this.$request('post', linksForPortal, params)
    },
    bindResizeEvent() {
      // 监听页面比例变化
      window.addEventListener('resize', () => {
        this.checkMobile()
      })
    },
    bindVisibilityChange() {
      // 监听页面切换（主要用于监听打开app）
      window.document.addEventListener('visibilitychange', () => {
        if (this.openApping) {
          this.openApping = false
        }

        this.clearCheckAppTimer()
        this.closeLoading()
      })
    }
  },
  created() {
    this.checkMobile()
    this.getLinks()
  },
  mounted() {
    this.bindResizeEvent()
    this.bindVisibilityChange()
    this.pageEnterTime = new Date().getTime();
    // window._hmt && window._hmt.push(['_trackEvent', '产品介绍页展示次数', 'click', '/problem', this.pageEnterTime+','+JSON.stringify(this.user)]);
  }
}
</script>

<style lang="scss" scoped>
  .portal-page {
    width: 100vw;
    height: 100vh;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    &.pc-bg {
      background-image: url('~@/assets/img/portal/bg-pc.png');
    }
    &.mobile-bg {
      background-image: url('~@/assets/img/portal/bg-pc.png');
    }
    &.pc-pd {
      padding: 6.48vh 4.4vw 11.67vh 4.27vw;
    }
    &.mobile-pd {
      padding: 7vh 5.68vw 5.5vh;
    }
    .logo-pc {
      width: 13.65vw;
      height: auto;
      position: absolute;
      top: 7.78vh;
      right: 4.375vw;
    }
    .logo-mobile {
      width: 30.22vw;
      height: auto;
      position: absolute;
      bottom: 5.34vh;
      left: 34.89vw;
    }
    .slogon-pc {
      width: 25.83vw;
      height: 16.3vh;
      position: absolute;
      left: 4.27vw;
      top: 6.48vh;
      img {
        width: 100%;
        height: 12.96vh;
        position: absolute;
        top: 0;
      }
      .welcome {
        color: #FDFCFC;
        font-size: 2.2vw;
        line-height: 5.8vh;
        position: absolute;
        bottom: 1vh;
        width: 40vw;
        font-family: 'Source Han Sans CN', sans-serif;
      }
    }
    .slogon-mobile {
      width: 44.1vw;
      height: 7.22vh;
      position: absolute;
      left: 8.36vw;
      top: 6.81vh;
      img {
        width: 100%;
        height: 5.75vh;
        position: absolute;
        top: 0;
      }
      .welcome {
        color: #FDFCFC;
        font-size: 4.7vw;
        line-height: 2.8vh;
        position: absolute;
        bottom: 0;
      }
    }
    .info-pc {
      width: 43.23vw;
      // height: 59.72vh;
      height: auto;
      position: absolute;
      left: 4.27vw;
      bottom: 7.6vh;
    }
    .info-mobile {
      position: absolute;
      top: 15.27vh;
      height: 30.17vh;
      display: flex;
      justify-content: center;
      width: 100%;
      left: 0;
      img {
        width: auto;
        height: 100%;
      }
      // width: 84.18vw;
      // left: 7.91vw;
    }
    .entrances-pc {
      width: 37.5vw;
      height: 54.81vh;
      position: absolute;
      right: 7.5vw;
      bottom: 14.81vh;
      display: grid;
      grid-row-gap: 2.4vh;
      grid-column-gap: 1.15vw;
      grid-auto-flow: row;
      grid-template-columns: 50% 50%;
      grid-template-rows: 33.33% 33.33% 33.33%;
      .item {
        border-radius: 10px;
        background-color: rgba(255,255,255,0.8);
        box-shadow: 0px 0px 12px 2px rgba(181,248,251,0.5);
        display: flex;
        align-items: center;
        padding: 0 0 0 2.6vw;
        cursor: pointer;
        img {
          width: 5.1vw;
          height: auto;
        }
        span {
          font-size: 1.36vw;
          flex: 1;
          text-align: center;
          color: #333;
        }
      }
      .item-1 {
        grid-column-start: 1;
        grid-column-end: 3;
        justify-content: space-between;
        padding: 0 3.75vw;
        .lr {
          width: 2.5vw;
          height: auto;
        }
        .content {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            margin: 0 2.08vw 0 0;
          }
        }
      }
    }
    .entrances-mobile {
      width: 88.44vw;
      height: 33.5vh;
      position: absolute;
      right: 5.78vw;
      bottom: 18.68vh;
      display: grid;
      grid-row-gap: 1.52vh;
      grid-column-gap: 2.84vw;
      grid-auto-flow: row;
      grid-template-columns: 50% 50%;
      grid-template-rows: 33.33% 33.33% 33.33%;
      .item {
        border-radius: 10px;
        background-color: rgba(255,255,255,0.8);
        box-shadow: 0px 0px 12px 2px rgba(181,248,251,0.5);
        display: flex;
        align-items: center;
        padding: 0 0 0 6.4vw;
        img {
          width: 11.82vw;
          height: auto;
        }
        span {
          font-size: 3.2vw;
          flex: 1;
          text-align: center;
          color: #333;
        }
      }
      .item-1 {
        grid-column-start: 1;
        grid-column-end: 3;
        justify-content: space-between;
        padding: 0 9.06vw;
        .lr {
          width: 5.95vw;
          height: auto;
        }
        .content {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            margin: 0 5.15vw 0 0;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .seller-info-pop {
    .el-dialog__header {
      background-color: #fff !important;
    }
    .seller-list-mobile {
      width: 90%;
      margin: 0 auto;
      line-height: 30px;
      .info {
        display: flex;
        .label {
          width: 70px;
          flex-shrink: 0;
          color: #939090;
        }
        .title {
          font-size: 16px;
        }
      }
    }
  }
</style>